import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { Step } from '../../../shared/interfaces/step';
import { Promotion } from '../../../shared/interfaces/steps/promotion';
import { SpinTheWheelComponent } from '../../../games/components/spin-the-wheel/spin-the-wheel.component';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { Prize } from '../../../games/interfaces/prize';
import { PromotionService } from '../../../shared/services/promotion.service';
import { RewardsCardUnlockComponent } from '../rewards-card-unlock/rewards-card-unlock.component';
import { Sale } from '../../../shared/interfaces/sale';
import { Game, WinningPrize } from '../../../games/interfaces/game';

@Component({
    selector: 'app-step-display-promotion',
    standalone: true,
    imports: [CommonModule, RewardsCardUnlockComponent, SpinTheWheelComponent],
    templateUrl: './step-display-promotion.component.html',
    styleUrl: './step-display-promotion.component.scss',
})
export class StepDisplayPromotionComponent implements OnInit {
    @Output() public readonly prizeClaimed = new EventEmitter<void>();

    @Input() public formGroup: FormGroup | undefined;

    @Input() public sale: Sale | undefined;

    @Input() public step: Step | undefined;

    public locked = false;

    private _prizes = new BehaviorSubject<Prize[]>([]);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public readonly prizes$ = this._prizes.asObservable();

    // eslint-disable-next-line @typescript-eslint/member-ordering
    private _winningPrize = new BehaviorSubject<WinningPrize | undefined>(undefined);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public readonly winningPrize$ = this._winningPrize.asObservable();

    public constructor(
        private readonly promo: PromotionService,
    ) {
    }

    public get isStandalone(): boolean {
        return (this.step as Promotion)?.settings?.standalone ?? false;
    }

    public get requiresRewardsCard(): boolean {
        return (this.step as Promotion)?.settings?.requires_rewards_card ?? false;
    }

    public ngOnInit(): void {
        const game = this.step?.metadata?.['game'] as Game;
        if (game?.prizes) {
            this._prizes.next(game.prizes);
        }

        this.locked = this.requiresRewardsCard && this.isStandalone;
    }

    public onUnlocked(): void {
        this.locked = false;
    }

    public drawWinner = async (): Promise<WinningPrize | null> => {
        if (!this.sale?.id || !this.step?.id) return null;
        return await firstValueFrom(this.promo.drawWinner(this.sale.id as number, this.step.id));
    };
}
